import { IConstraintDrillFracInterferenceInteractingTargetFormation } from '../../interfaces/iconstraint-drill-frac-interference-interacting-target-formation';
import { ConstraintDrillFracInterferenceDetail } from '../constraint-drill-frac-interference-detail';
import { TargetFormation } from '../target-formation';

export class ConstraintDrillFracInterferenceInteractingTargetFormationBase {
  ConstraintDrillFracInterferenceInteractingTargetFormationId: number;
  ConstraintDrillFracInterferenceDetailId: number;
  InteractingTargetFormationId: number;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  ConstraintDrillFracInterferenceDetail?: ConstraintDrillFracInterferenceDetail;
  TargetFormation?: TargetFormation;

  constructor(item?: IConstraintDrillFracInterferenceInteractingTargetFormation) {
    if (item) {

      this.ConstraintDrillFracInterferenceInteractingTargetFormationId = item.ConstraintDrillFracInterferenceInteractingTargetFormationId;
      this.ConstraintDrillFracInterferenceDetailId = item.ConstraintDrillFracInterferenceDetailId;
      this.InteractingTargetFormationId = item.InteractingTargetFormationId;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.ConstraintDrillFracInterferenceDetail = new ConstraintDrillFracInterferenceDetail(item.ConstraintDrillFracInterferenceDetail);
      this.TargetFormation = new TargetFormation(item.TargetFormation);
    }
  }
}